import styled, { css } from 'styled-components';
import { media, when } from 'utils';

export type VariantProps = 'watch' | 'submit' | 'default';

interface LinkButtonBaseProps {
  variant: VariantProps;
}

const baseStyles = css`
  color: #fff;
  border: none;
  position: relative;
  top: 1px;

  ${media.tablet`
    font-size: 1.2rem;
    width: 10rem;
  `}

  ${media.mobileL`
    font-size: 1rem;
    min-width: 8rem;
    height: 3rem;
    padding: 0;
  `}
`;

const variantStyles = {
  submit: css`
    background-color: #d34612;

    &:hover {
      background-color: rgb(200, 55, 15);
    }

    &:active {
      top: 1px;
    }

    ${when('disabled')`
      background-color: #979a9c;

      &:hover {
        background-color: #979a9c;
        cursor: default;
      }

      &:active {
        top: 0px;
      }
    `}
  `,
  watch: css`
    background-color: #164036;
    border: 2px solid #164036;
    gap: 1rem;

    &:after {
      content: '';
      border-top: 0.4rem solid transparent;
      border-bottom: 0.4rem solid transparent;
      border-left: 0.8rem solid #fff;
    }

    &:hover {
      background-color: #fff;
      color: #164036;

      &:after {
        border-left-color: #164036;
      }
    }
  `,
  default: css`
    background-color: #fff;
    color: #000;
    border: 1px solid black;

    &:hover {
      color: #646769;
    }
  `,
};

const commonStyles = css<LinkButtonBaseProps>`
  width: 14.5rem;
  height: 3.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3rem;
  font-weight: bold;
  font-size: 1.3rem;
  outline: none;
  cursor: pointer;

  ${({ variant }) => variantStyles[variant]}

  ${media.tablet`
    width: 10rem;
  `}
`;

export const StyledButtonBase = styled.button<LinkButtonBaseProps>`
  ${baseStyles}
  ${commonStyles}
`;

export const StyledButton = styled(StyledButtonBase).attrs({ as: 'button' })``;
export const StyledLink = styled(StyledButtonBase).attrs({ as: 'a' })``;
